export const app = {
  title: '新物流系统',
  warehouseTypes: [{
      value: 'SJL',
      text: 'SJL纳入场所'
    },
    {
      value: 'SC',
      text: 'SC纳入场所'
    }
  ],
  weekdays: '日,一,二,三,四,五,六'
}
export const M0010 = {
  title: '用户搜索'
}